export default class {
  /**
   * @function editElement
   * @param  {type} params {description}
   * @return {type} {description}
   */
  editElement(params) {
    return `
        <div class='body'>
            <p>Changes name file of <code>"${params.title}"</code></p>
            <form class='modal_form flex flex-vertical-center' id='form_new_name'>
                <input id='new_name_input' class='form-control m0' type='text' name='new_name' value="${params.title}">
                <button type="submit" class="tingle-btn tingle-btn--primary tingle-btn--pull-right">Rename</button>
            </form>
        </div>`
      .replace(/\s\s/g, "")
      .replace(/>\s/g, ">");
  }
  /**
   * @function uploadDropzone
   * @param  {type} params {description}
   * @return {type} {description}
   */
  uploadDropzone() {
    return `
        <style id="document_dropzone_style">
            #document_dropzone{
                display: none;
            }
            #files_input{
                position: absolute;
                left: 0;
                top: 0;
                visibility: hidden;
            }
            #document_dropzone.show{
                display: block;
            }
            #document_dropzone #dz_label{
                display: flex;
                position: fixed; 
                z-index: 9999999;
                background: rgba(229, 124, 41,0.2);
                left: 0;
                right:0;
                top:0;
                bottom:0;
                width:100%;
                justify-content: center;
                align-items: center;
                border:none;
                box-shadow: none;
                flex-direction: column;
            }
            #document_dropzone #dz_label button{
                color: #fff;
                background: rgb(229, 124, 41);
                padding: 10px 15px;
                border:none;
                margin: 10px;
            }
            #dz_thumbnail{
                display: none;
            }
            #dz_thumbnail .fa{
                display: block;
                font-size: 80px;
                background: rgb(229, 124, 42);
                padding: 20px;
                color:#fff;
                width: 110px;
                margin: 0 auto;
                position: relative;
                top:100vh;
            }
            #dz_thumbnail #dz_file_name {
                opacity: 0;
                color: #fff;
                font-family: monospace;
                padding: 0 8px;
                font-weight: 600;
                font-size: 17px;
                transition: .3s opacity ;
            }
            #dz_thumbnail #dz_file_name.display {
                opacity: 1;
            }
            .dz_hidden{
                display: none;
            }
            .dz_ctas{
                display: flex;
            }
            .dz_ctas .extra{
                display: none;
            }
            .dz_log{
                max-height: 500px;
                width: 600px;
                background: rgba(0,0,0,.4);
                color: #fff;
                overflow: auto;
                padding: 10px;
            }
        </style>
        <div id="document_dropzone">
            <form id="document_dropzone_form">
                <label for="files_input" id="dz_label">
                    <div id="dz_thumbnail">
                        <i class="fa fa-file-archive-o"></i>
                        <h3 id="dz_file_name"></h3>
                    </div>
                    <div class="dz_ctas">
                        <button type="button" id="dz_upload_btn"onclick="$(files_input).trigger('click')">
                            Upload a .zip file to "${CodeEditor.Main.themeName()}"
                        </button>
                        <div class="extra">
                            <button id="dz_overwrite" type="button" class="dz_hidden">
                                Overwite everything
                            </button>
                            <button id="dz_keepfiles" type="button" class="dz_hidden">
                                Upload all entries ( keep all existing files)
                            </button>
                            <button id="dz_cancel" type="button" class="dz_hidden">
                                Cancel
                            </button>
                        </div>
                        </div>
                        <div class="dz_log dz_hidden"></div>
                </label>
                <input name="files[]" multiple type="file" id="files_input" >
            </form>
        </div>`
      .replace(/\s\s/g, "")
      .replace(/>\s/g, ">")
      .replace(/;\n/g, ";");
  }
}
